import axios from '@/axios';

export default {
    namespaced: true,
    state() {
        return {
            categories: [],
            accessories: [],
            spareparts: []
        }
    },
    getters: {
        categories(state) {
            return state.categories;
        },
        accesories(state) {
            return state.accessories;
        },
        spareparts(state) {
            return state.spareparts;
        }
    },
    mutations: {
        setCategories(state, data) {
            state.categories = data;
        },
        setAccesoriesCategory(state, data) {
            state.accessories = data;
        },
        setSparepartCategory(state, data) {
            state.spareparts = data
        }
    },
    actions: {
        getCategories({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('sales-and-purchase/drcc/item/categories').then((response) => {
                    commit('setCategories', response.data.data);
                    resolve(response.data.data);
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
        // Accessories
        getCategoriesAccessories({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios.get('sales-and-purchase/category/accessories', {
                    params: params
                }).then((response) => {
                    commit('setAccesoriesCategory', response.data.data);
                    resolve(response.data.metadata);
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
        getCategoriesAccessoriesById({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios.get('sales-and-purchase/category/accessories/' + id )
                .then((response) => {
                    resolve(response.data);
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
        deleteCategoriesAccessories({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios.delete('sales-and-purchase/category/accessories/' + id).then((response) => {
                    resolve();
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
        updateCategoriesAccessories({ commit }, { id, payload }) {
            console.log(payload);
            
            return new Promise((resolve, reject) => {
                axios.put('sales-and-purchase/category/accessories/' + id, payload).then((response) => {
                    resolve();
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
        AddCategoriesAccessories({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios.post('sales-and-purchase/category/accessories', payload).then((response) => {
                    resolve();
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
        getCategoriesSparepart({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios.get('sales-and-purchase/category/spareparts', {
                    params: params
                }).then((response) => {
                    commit('setSparepartCategory', response.data.data);
                    resolve(response.data.metadata);
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
        getCategoriesSparepartById({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios.get('sales-and-purchase/category/spareparts/' + id )
                .then((response) => {
                    resolve(response.data);
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
        deleteCategoriesSparepart({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios.delete('sales-and-purchase/category/spareparts/' + id).then((response) => {
                    resolve();
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
        updateCategoriesSparepart({ commit }, {id, payload }) {
            return new Promise((resolve, reject) => {
                axios.put('sales-and-purchase/category/spareparts/' + id, payload).then((response) => {

                    resolve();
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
        AddCategoriesSparepart({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios.post('sales-and-purchase/category/spareparts', payload).then((response) => {
                    resolve();
                }).catch((e) => {
                    console.log(e)
                    reject(e);
                })
            })
        },
    }
}